// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // url: '//' + window.location.hostname + ':3000/api/qt',
  url: 'http://localhost:3000/api/v2'
  // url: 'https://payments.quintustech.in/api/v2'
  // url: 'http://192.168.1.16:3000/api/v2'
};
